module.exports = __webpack_public_path__ + "888f8713bac67432a79632a8575bca87.png";